
const gustibusConfigData = JSON.parse(config_data.gustibusConfigData);

export default gustibusConfigData;